import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlService} from './url.service';

@Injectable()
export class CertificationService {
    private BASE_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/certifications';
    }

    getMostRecentCertifications(): any {
        return this.http.get(this.BASE_URL + '/mostRecentForTypes');
    }

    importCertification(): any {
        return this.http.post(this.BASE_URL + '/import', {});
    }

    // Get the Tags for the types that are specified in the LearnerNation import config.
    getAutoImportTags(): any {
        return this.http.get(this.BASE_URL + '/autoImportTags');
    }
}
